import React from 'react';

export const LoadingSpinner = ({ size = 'medium', color = '#667eea' }) => {
  const sizes = {
    small: '20px',
    medium: '40px',
    large: '60px'
  };

  return (
    <div style={{
      display: 'inline-block',
      width: sizes[size],
      height: sizes[size],
      border: `3px solid rgba(102, 126, 234, 0.2)`,
      borderTopColor: color,
      borderRadius: '50%',
      animation: 'spin 0.8s linear infinite'
    }} />
  );
};

export const SkeletonCard = ({ height = '100px' }) => {
  return (
    <div style={{
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
      height,
      borderRadius: '12px',
      marginBottom: '15px'
    }} />
  );
};

export const SkeletonText = ({ width = '100%', height = '16px' }) => {
  return (
    <div style={{
      background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s infinite',
      width,
      height,
      borderRadius: '4px',
      marginBottom: '8px'
    }} />
  );
};

export const FadeIn = ({ children, delay = 0 }) => {
  return (
    <div style={{
      animation: `fadeIn 0.3s ease-in ${delay}ms both`
    }}>
      {children}
    </div>
  );
};

export const SlideIn = ({ children, direction = 'up', delay = 0 }) => {
  const animations = {
    up: 'slideInUp',
    down: 'slideInDown',
    left: 'slideInLeft',
    right: 'slideInRight'
  };

  return (
    <div style={{
      animation: `${animations[direction]} 0.4s ease-out ${delay}ms both`
    }}>
      {children}
    </div>
  );
};

export const LoadingOverlay = ({ message = 'Ładowanie...' }) => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0, 0, 0, 0.5)',
      backdropFilter: 'blur(4px)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeIn 0.2s ease-in'
    }}>
      <LoadingSpinner size="large" color="#fff" />
      <div style={{
        color: 'white',
        marginTop: '20px',
        fontSize: '18px',
        fontWeight: 'bold'
      }}>
        {message}
      </div>
    </div>
  );
};
